
import { Permission } from "../types";
import { savePermissionsToStorage } from "../storage/localStorageManager";
import { savePermissionsToDatabase } from "../storage/databaseManager";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

/**
 * Save permissions to both database and localStorage
 */
export const savePermissions = async (permissions: Permission[]): Promise<boolean> => {
  try {
    console.log("[PermissionsStorage] Saving permissions to both database and localStorage");
    const timestamp = new Date().toISOString();
    console.log(`[${timestamp}] [PermissionsStorage] Starting comprehensive save operation`);
    
    // First save to database (source of truth)
    const dbSuccess = await savePermissionsToDatabase(permissions);
    
    if (!dbSuccess) {
      console.error(`[${timestamp}] [PermissionsStorage] Database save failed, aborting entire save operation`);
      toast.error("Database opslaan mislukt. Controleer of RLS is uitgeschakeld voor de role_permissions tabel.");
      return false;
    }
    
    // If database save succeeds, update localStorage cache
    console.log(`[${timestamp}] [PermissionsStorage] Database save successful, updating local cache`);
    
    // After successful database save, reload the permissions from database to get the new UUIDs
    try {
      const { data: updatedPermissions, error } = await supabase
        .from('role_permissions')
        .select('*');
        
      if (!error && updatedPermissions && updatedPermissions.length > 0) {
        console.log(`[${timestamp}] [PermissionsStorage] Updating local cache with database records`);
        const localSuccess = savePermissionsToStorage(updatedPermissions);
        
        if (!localSuccess) {
          console.warn(`[${timestamp}] [PermissionsStorage] Warning: localStorage cache update failed, but database save was successful`);
        }
      }
    } catch (reloadError) {
      console.warn(`[${timestamp}] [PermissionsStorage] Failed to reload permissions after save:`, reloadError);
    }
    
    console.log(`[${timestamp}] [PermissionsStorage] Save operation completed successfully`);
    return true;
  } catch (error) {
    console.error("[PermissionsStorage] Error in savePermissions:", error);
    toast.error("Fout bij opslaan van rechten");
    return false;
  }
};
